import classNames from 'classnames';
import type { ReactNode } from 'react';

import twoRailsStyles from './ConversionBarTwoRails.module.scss';

type ConversionBarTwoRailsActionsRowProps = {
  leading: ReactNode;
  cta: ReactNode;
  ctaClassName?: string;
};

export const ConversionBarTwoRailsActionsRow: React.FC<ConversionBarTwoRailsActionsRowProps> = ({
  leading,
  cta,
  ctaClassName,
}) => (
  <div className={twoRailsStyles.actionsRow}>
    <div className={twoRailsStyles.leading}>{leading}</div>
    <div className={classNames(twoRailsStyles.cta, ctaClassName)}>{cta}</div>
  </div>
);
